import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, map, mergeMap, of, switchMap } from "rxjs";
import {
  acceptMyInvitation,
  acceptMyInvitationFailure,
  acceptMyInvitationSuccess,
  declineInvitationSuccess,
  declineMyInvitation,
  declineMyInvitationFailure,
  loadMyInvitations,
  loadMyInvitationsFailure,
  loadMyInvitationsSuccess,
  loadMyRoleAssignments
} from "@my-account/store/actions";
import { NotificationService } from "@core/services";
import { MyInvitationService } from "@my-account/services";

@Injectable()
export class MyInvitationEffects {
  loadMyInvitations$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(loadMyInvitations),
      switchMap(() =>
        this.myInvitationService.getMyInvitations().pipe(
          map((invitations) => loadMyInvitationsSuccess({ invitations: invitations })),
          catchError(() => of(loadMyInvitationsFailure()))
        )
      )
    );
  });

  acceptMyInvitation = createEffect(() => {
    return this.actions$.pipe(
      ofType(acceptMyInvitation),
      switchMap(({ invitationId }) =>
        this.myInvitationService.acceptMyInvitation(invitationId).pipe(
          mergeMap(() => [
            acceptMyInvitationSuccess({ invitationId: invitationId }),
            loadMyInvitations(),
            loadMyRoleAssignments()
          ]),
          catchError(() => of(acceptMyInvitationFailure({ invitationId: invitationId })))
        )
      )
    );
  });

  declineMyInvitation = createEffect(() => {
    return this.actions$.pipe(
      ofType(declineMyInvitation),
      switchMap(({ invitationId }) =>
        this.myInvitationService.declineMyInvitation(invitationId).pipe(
          map(() => declineInvitationSuccess({ invitationId: invitationId })),
          catchError(() => of(declineMyInvitationFailure({ invitationId: invitationId })))
        )
      )
    );
  });

  notifyAcceptInvitationSuccess = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(acceptMyInvitationSuccess),
        map(() =>
          this.notificationService.showTranslatedNotification(
            "notifications.invitation_accept_success",
            "confirmation"
          )
        )
      );
    },
    { dispatch: false }
  );

  notifyDeclineInvitationSuccess = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(declineInvitationSuccess),
        map(() =>
          this.notificationService.showTranslatedNotification(
            "notifications.invitation_decline_success",
            "confirmation"
          )
        )
      );
    },
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private myInvitationService: MyInvitationService,
    private notificationService: NotificationService
  ) {}
}
